import Grid from '@mui/material/Grid';
import { Box, Button, Paper, TextField, Typography } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import 'dayjs/locale/de';
import AirportsGrid, { IAirportsGridRef } from './AirportsGrid';

function Airports() {
    const [searchText, setSearchText] = useState<string | undefined>(undefined);
    const [filterTerm, setFilterTerm] = useState<string | undefined>(undefined);
    const gridRef = useRef<IAirportsGridRef>(null);


    useEffect(() => {
        const timeoutId = setTimeout(() => {
            setFilterTerm(searchText?.toUpperCase()); 
        }, 1000);
    
        return () => clearTimeout(timeoutId);
    }, [searchText]);

    const handleFilterReset = () => {
        setSearchText('');
        setFilterTerm('');
        gridRef.current?.clearFilter();
    };

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                
                <Paper sx={{ p: 2, paddingBottom: 2 , display: 'flex', flexWrap: 'wrap', flexDirection: { xs: 'column', md: 'row' }, alignItems: 'center' }} elevation={3}>
                <Box sx={{flexGrow: 1, mr: { xs: 0, md: 2 }, mb: { xs: 2, md: 0 } }}>
                        <Typography variant="subtitle1" component="h2" sx={{ textTransform: 'uppercase' }}>
                            Airports
                        </Typography>
                    </Box>
                    </Paper>
            </Grid>
            <Grid item xs={12}>
                <Paper sx={{p: 2 }} elevation={3}>
                    <Box sx={{ display: 'flex', gap: 2 }}>
                        <TextField label="Search" variant="outlined" fullWidth size="small" value={searchText} onChange={(e) => setSearchText(e.target.value)}/>
                        <Button variant="contained" onClick={handleFilterReset} >
                            Reset
                        </Button>
                    </Box>
                </Paper>
            </Grid>

            <Grid item xs={12}>
                <Paper sx={{ p: 0, display: 'flex', flexDirection: 'column', minHeight: '100px' }} elevation={3}>
                    <AirportsGrid ref={gridRef} filterTerm={filterTerm}/>
                </Paper>
            </Grid>
        </Grid>
    );
}

export default Airports;